import { SquareButton } from "@themuse/design-system";

import { JobApplyButton } from "./JobApplyButton";

import styles from "./JobApplyButtonSideBarModule.module.scss";

interface JobApplyButtonSideBarModuleProps {
    jobState: string;
    jobId: number;
    trackJobApplyProps: any;
    mobile?: boolean;
    setIsOpen?: (x: boolean) => void;
    isDirectApply: boolean;
    directApplyVendor?: string;
}

export const JobApplyButtonSideBarModule = (props: JobApplyButtonSideBarModuleProps) => {
    const {
        jobState,
        jobId,
        trackJobApplyProps,
        mobile = false,
        setIsOpen,
        isDirectApply,
        directApplyVendor
    } = props;

    return (
        <div className={`${styles.jobApplyContainer} ${mobile ? styles.mobile : ""}`}>
            {jobState === "live" ? (
                <JobApplyButton
                    className={styles.applyButton}
                    jobId={jobId}
                    trackingProps={trackJobApplyProps}
                    setIsOpen={setIsOpen}
                    isDirectApply={isDirectApply}
                    directApplyVendor={directApplyVendor}
                />
            ) : (
                <>
                    <p className={styles.archivedJobMessage}>This job is no longer available.</p>
                    <SquareButton
                        className={styles.applyButton}
                        href="/search"
                        target="_blank"
                        color="mint"
                    >
                        Search all jobs
                    </SquareButton>
                </>
            ) }
        </div>
    );
};
